import { Navigate, useNavigate } from 'react-router-dom';
import { useIsActiveSubscription } from '../hooks/use-is-active-subscription';
import { useIsWorkpaperRole } from '../hooks/use-is-workpaper-role';
import { useFirmContext } from '../providers/FirmProvider';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';

import PageTitle from '../components/PageTitle';
import UpdateTrialBalanceForm from '../features/update-trial-balance/UpdateTrialBalanceForm';

function UpdateTrialBalancePage(): JSX.Element {
    const navigate = useNavigate();
    const activeSubscription = useIsActiveSubscription();

    const { shortId } = useFirmContext();
    const { isGuest } = useIsWorkpaperRole();
    const { id: workpaperId } = useWorkpaperContext();

    if (!activeSubscription || isGuest) {
        return <Navigate to=".." />;
    }

    function redirectBackToTrialBalancePage(): void {
        navigate(`/${shortId}/workpapers/${workpaperId}/trial-balance`);
    }

    return (
        <div className="pb-4">
            <div className="pb-4 border-b">
                <PageTitle title="Update Trial Balance" />
            </div>
            <UpdateTrialBalanceForm onClose={redirectBackToTrialBalancePage} />
        </div>
    );
}

export default UpdateTrialBalancePage;
